// extracted by mini-css-extract-plugin
export default {"content":"erhPAb1DYn"};